import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },*/
  {
     key: 'id',
     field: FIELDS.ID,
     title: 'WO No',
     label: 'WO No',
     cell: 'navigation',
     sortable: true,
     hidden: false,
     locked: true,
     width: 75,
  },{
     key: 'statusName',
     field: FIELDS.STATUS_NAME,
     title: 'Status',
     label: 'Status',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'soDate',
     field: FIELDS.SODATE,
     title: 'WO Date',
     label: 'WO Date',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateShipped',
     field: FIELDS.DATE_SHIPPED,
     title: 'Date Shipped',
     label: 'Date Shipped',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateReceived',
     field: FIELDS.DATE_RECEIVED,
     title: 'Date Received',
     label: 'Date Received',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dueDate',
     field: FIELDS.DUE_DATE,
     title: 'Due Date',
     label: 'Due Date',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'aging',
     field: FIELDS.AGING,
     title: 'Aging',
     label: 'Aging',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'companyName',
     field: FIELDS.COMPANY_NAME,
     title: 'Company',
     label: 'Company',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'contactFullName',
     field: FIELDS.CONTACT_FULL_NAME,
     title: 'Contact',
     label: 'Contact',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'contactEmail',
     field: FIELDS.CONTACT_EMAIL,
     title: 'Contact Email',
     label: 'Contact Email',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'billingAddress',
     field: FIELDS.BILLING_ADDRESS,
     title: 'Bill To',
     label: 'Bill To',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingAddress',
     field: FIELDS.SHIPPING_ADDRESS,
     title: 'Ship To',
     label: 'Ship To',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'buyerUserFullName',
     field: FIELDS.BUYER_USER_FULL_NAME,
     title: 'Buyer',
     label: 'Buyer',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'isAuthorized',
     field: FIELDS.IS_AUTHORIZED,
     title: 'Authorized',
     label: 'Authorized',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'currencyTypeName',
     field: FIELDS.CURRENCY_TYPE_NAME,
     title: 'Currency',
     label: 'Currency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'billingTermName',
     field: FIELDS.BILLING_TERM_NAME,
     title: 'Billing Terms',
     label: 'Billing Terms',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'comments',
     field: FIELDS.COMMENTS,
     title: 'Comments',
     label: 'Comments',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'internalComments',
     field: FIELDS.INTERNAL_COMMENTS,
     title: 'Internal Comments',
     label: 'Internal Comments',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingMethodName',
     field: FIELDS.SHIPPING_METHOD_NAME,
     title: 'Ship Method',
     label: 'Ship Method',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingProviderName',
     field: FIELDS.SHIPPING_PROVIDER_NAME,
     title: 'Ship Via',
     label: 'Ship Via',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shipOnVendorAccount',
     field: FIELDS.SHIP_ON_VENDOR_ACCOUNT,
     title: 'Ship On Vendor Account',
     label: 'Ship On Vendor Account',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingAccountNumber',
     field: FIELDS.SHIPPING_ACCOUNT_NUMBER,
     title: 'Ship Acct No',
     label: 'Ship Acct No',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'trackingNumber',
     field: FIELDS.TRACKING_NUMBER,
     title: 'Tracking No',
     label: 'Tracking No',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'testHouseQuoteNumber',
     field: FIELDS.TEST_HOUSE_QUOTE_NUMBER,
     title: 'TH Quote No',
     label: 'TH Quote No',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'salesTypeId',
     field: FIELDS.SALES_TYPE_ID,
     title: 'SalesTypeId',
     label: 'SalesTypeId',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'salesTypeName',
     field: FIELDS.SALES_TYPE_NAME,
     title: 'Sales Type',
     label: 'Sales Type',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'incoTermName',
     field: FIELDS.INCO_TERM_NAME,
     title: 'Incoterms',
     label: 'Incoterms',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'isTaxable',
     field: FIELDS.IS_TAXABLE,
     title: 'Taxable',
     label: 'Taxable',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'taxRate',
     field: FIELDS.TAX_RATE,
     title: 'Tax Rate',
     label: 'Tax Rate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'exchangeRate',
     field: FIELDS.EXCHANGE_RATE,
     title: 'Exch. Rate',
     label: 'Exch. Rate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'subTotal',
     field: FIELDS.SUB_TOTAL,
     title: 'Sub Total',
     label: 'Sub Total',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'totalLineCost',
     field: FIELDS.TOTAL_LINE_COST,
     title: 'Total Line Cost',
     label: 'Total Line Cost',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesTaxable',
     field: FIELDS.TOTAL_CHARGES_TAXABLE,
     title: 'Total Charges Tax',
     label: 'Total Charges Tax',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesNonTaxable',
     field: FIELDS.TOTAL_CHARGES_NON_TAXABLE,
     title: 'Total Charges Non Tax',
     label: 'Total Charges Non Tax',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalCharges',
     field: FIELDS.TOTAL_CHARGES,
     title: 'Total Charges',
     label: 'Total Charges',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'totalChargesCost',
     field: FIELDS.TOTAL_CHARGES_COST,
     title: 'Total Charges Cost',
     label: 'Total Charges Cost',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'tax',
     field: FIELDS.TAX,
     title: 'Tax',
     label: 'Tax',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'total',
     field: FIELDS.TOTAL,
     title: 'Total',
     label: 'Total',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'subTotalConverted',
     field: FIELDS.SUB_TOTAL_CONVERTED,
     title: 'Subtotal Conv',
     label: 'Subtotal Conv',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalLineCostConverted',
     field: FIELDS.TOTAL_LINE_COST_CONVERTED,
     title: 'Total Line Cost Conv',
     label: 'Total Line Cost Conv',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesTaxableConverted',
     field: FIELDS.TOTAL_CHARGES_TAXABLE_CONVERTED,
     title: 'Total Charges Tax',
     label: 'Total Charges Tax',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesNonTaxableConverted',
     field: FIELDS.TOTAL_CHARGES_NON_TAXABLE_CONVERTED,
     title: 'Total Charges Non Tax Conv',
     label: 'Total Charges Non Tax Conv',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesConverted',
     field: FIELDS.TOTAL_CHARGES_CONVERTED,
     title: 'Total Charges Conv',
     label: 'Total Charges Conv',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesCostConverted',
     field: FIELDS.TOTAL_CHARGES_COST_CONVERTED,
     title: 'Total Charges Cost Conv',
     label: 'Total Charges Cost Conv',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalConverted',
     field: FIELDS.TOTAL_CONVERTED,
     title: 'Total Conv',
     label: 'Total Conv',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'amountPaid',
     field: FIELDS.AMOUNT_PAID,
     title: 'Amount Paid',
     label: 'Amount Paid',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'balance',
     field: FIELDS.BALANCE,
     title: 'Balance',
     label: 'Balance',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'poDate',
     field: FIELDS.PODATE,
     title: 'PO Date',
     label: 'PO Date',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'creditAmount',
     field: FIELDS.CREDIT_AMOUNT,
     title: 'Credit Amount',
     label: 'Credit Amount',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'isPaid',
     field: FIELDS.IS_PAID,
     title: 'Paid',
     label: 'Paid',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'onHold',
     field: FIELDS.ON_HOLD,
     title: 'On Hold',
     label: 'On Hold',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'authorizedByUserFullName',
     field: FIELDS.AUTHORIZED_BY_USER_FULL_NAME,
     title: 'Authorized By',
     label: 'Authorized By',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'createdByUserFullName',
     field: FIELDS.CREATED_BY_USER_FULL_NAME,
     title: 'Created By',
     label: 'Created By',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'modifiedByUserFullName',
     field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
     title: 'Modified By',
     label: 'Modified By',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateAuthorized',
     field: FIELDS.DATE_AUTHORIZED,
     title: 'Date Authorized',
     label: 'Date Authorized',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateSent',
     field: FIELDS.DATE_SENT,
     title: 'Date Sent',
     label: 'Date Sent',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'Date Created',
     label: 'Date Created',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateModified',
     field: FIELDS.DATE_MODIFIED,
     title: 'Date Modified',
     label: 'Date Modified',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'active',
     field: FIELDS.ACTIVE,
     title: 'Active',
     label: 'Active',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'serviceOrderId',
     field: FIELDS.SERVICE_ORDER_ID,
     title: 'ServiceOrderId',
     label: 'ServiceOrderId',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'purchaseOrderLineId',
     field: FIELDS.PURCHASE_ORDER_LINE_ID,
     title: 'PurchaseOrderLineId',
     label: 'PurchaseOrderLineId',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'inventoryId',
     field: FIELDS.INVENTORY_ID,
     title: 'InventoryId',
     label: 'InventoryId',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'quantity',
     field: FIELDS.QUANTITY,
     title: 'Quantity',
     label: 'Quantity',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'serviceOrderLineId',
     field: FIELDS.SERVICE_ORDER_LINE_ID,
     title: 'ServiceOrderLineId',
     label: 'ServiceOrderLineId',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'serviceItemTypeId',
     field: FIELDS.SERVICE_ITEM_TYPE_ID,
     title: 'ServiceItemTypeId',
     label: 'ServiceItemTypeId',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'serviceTypeName',
     field: FIELDS.SERVICE_TYPE_NAME,
     title: 'ServiceTypeName',
     label: 'ServiceTypeName',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'cost',
     field: FIELDS.COST,
     title: 'Cost',
     label: 'Cost',
     sortable: true,
     hidden: false,
     width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
